module.exports = __webpack_public_path__ + "img/share_and_Earn.ffd1ee98.png";